import { MdClose } from "react-icons/md";


const formatAmount = (
  amount,
  {
    showCurrency = true,
    currencySymbol = "₹",
  } = {}
) => {
  if (amount === null || amount === undefined || amount === "") {
    return "--";
  }

  const formatted = Number(amount).toLocaleString("en-IN");

  return showCurrency
    ? `${currencySymbol}${formatted}`
    : formatted;
};

const ModalProfileHeader = ({
  title,
  name,
  subtitle,
  amount,
  amountLabel = "Amount",
  image,
  onClose,
  showClose = true,
  amountColor = "text-gray-900",
  showCurrency = true,
  currencySymbol = "₹",
}) => {
  return (
    <>
      {/* Profile Section */}
      <div className="flex items-center justify-between px-4 py-4 bg-gradient-to-r from-slate-50 to-white border-b border-gray-100">
        {/* Left */}
        <div className="flex items-center gap-3 min-w-0">
          {/* Avatar */}
          <div className="h-12 w-12 rounded-full overflow-hidden bg-gray-200 flex items-center justify-center shrink-0">
            {image ? (
              <img
                src={image}
                alt={name}
                className="h-full w-full object-cover"
              />
            ) : (
              <span className="text-base font-semibold text-gray-500">
                {name?.charAt(0)?.toUpperCase()}
              </span>
            )}
          </div>

          {/* User Info */}
          <div className="flex flex-col min-w-0">
            <span className="text-[1.1rem] font-semibold text-gray-900 truncate">
              {name}
            </span>

            {subtitle && (
              <span className="text-[0.92rem] text-gray-500 truncate">
                {subtitle}
              </span>
            )}
          </div>
        </div>

        {/* Right */}
        {amount !== undefined && (
          <div className="flex flex-col items-end ml-4 shrink-0">
            <span className="text-sm text-gray-500">
              {amountLabel}
            </span>

            <span
              className={`text-2xl leading-none font-semibold tracking-tight ${amountColor}`}
            >
              {formatAmount(amount, {
                showCurrency,
                currencySymbol,
              })}
            </span>
          </div>
        )}
      </div>
    </>
  );
};

export default ModalProfileHeader;